import React, { useState } from "react";

const useCdn = () => {
  // Image classes defined in Bunny CDN.
  // About image processing: https://docs.bunny.net/docs/stream-image-processing
  const imageClasses = ["carousel"];

  const cdnImage = (
    imageClass = "",
    path = "",
    host = "https://cdn.imghoas.fi",
  ) => {
    if (imageClasses.indexOf(imageClass) === -1) {
      return Promise.reject("Invalid imageClass");
    }

    host = host.replace(/\/$/, ""); // Remove trailing slash
    path = `/${path.replace(/^\/$/, "")}`; // Force leading slash

    const url = new URL(host + path);
    url.searchParams.append("class", imageClass);

    return Promise.resolve(url.toString());
  };

  return {
    cdnImage,
  };
};

export default useCdn;
